
define('app/board/models/queueItemModel',[
	'jquery',
	'underscore',
	'backbone'
], function($, _, Backbone){
	var QueueItemModel = Backbone.Model.extend({	
		defaults: {
			id: null, //Just the draftablePlayerId
			playerPos: null,
			byeWeek: null,
			teamAbbr: null,
			fName: null,
			lName: null,
	    },

	    initialize: function() {
	    	
	    },
	});
	
	return QueueItemModel;  
});